import React from "react";
import MaliciousIpTable from "./MaliciousIpTable";
import MaliciousIpHeader from "./MaliciousIpHeader";
import { maliciousDataType } from "../constants";

type MaliciousIpTemplateProps = {
  data: maliciousDataType;
  isLoading: boolean;
  handleReleaseIp: (id: number) => void;
  filter: { [key: string]: string | string[] };
  setFilter: (val: string) => void;
  setPage: (val: number) => void;
  currentPage: number;
};

const MaliciousIpTemplate: React.FC<MaliciousIpTemplateProps> = ({
  data,
  isLoading,
  handleReleaseIp,
  filter,
  setFilter,
  setPage,
  currentPage,
}) => (
  <div className="malicious-container">
    <MaliciousIpHeader filter={filter} setFilter={setFilter} />
    <MaliciousIpTable
      data={data}
      handleReleaseIp={handleReleaseIp}
      isLoading={isLoading}
      setPage={setPage}
      currentPage={currentPage}
    />
  </div>
);

export default MaliciousIpTemplate;
